import { buildingGroundZ } from "building-generation/elements/level/buildingGroundZ";
import type { Building } from "building-types/building/buildingTypes";
import type { BuildingGeometryEmitter } from "building-types/geometry/buildingGeometryTypes";
import { FaceCategory } from "building-types/materials/faceCategories";
import { MS_Color__C } from "common/materials/library/designMaterialSrcDefaults";
import { DMC } from "common/materials/library/DMC";
import { arc2ByCenterStartAngle } from "geom/arc";
import { faceNew } from "geom/brep";
import { planeNew } from "geom/plane";
import { UVGeneration } from "geom/uv";
import { buildExteriorLayers } from "./buildingGeometryTools";

const GROUND_PLANE_RADIUS = 5000.0;

type BuildingForGroundGeometries = Pick<Building, "levels">;

/**
 * Generates the ground plane geometry for the building.
 * The ground plane is a large circular disc centered at the origin at the building's ground elevation.
 */
export function getGroundGeometries(building: BuildingForGroundGeometries, emitter: BuildingGeometryEmitter): void {
  const threeLayers = buildExteriorLayers();

  const groundZ = buildingGroundZ(building as Building);
  const groundLoop = arc2ByCenterStartAngle(0, 0, GROUND_PLANE_RADIUS, 0, -2 * Math.PI);
  const groundFace = faceNew([groundLoop], planeNew(0, 0, groundZ, 1, 0, 0, 0, 1, 0));

  emitter.emit({
    geom: groundFace,
    faceCategory: FaceCategory.GROUND,
    threeLayers,
    entityId: undefined,
    levelId: undefined,
    pickHandle: undefined,
    materialSlot: undefined,
    // Ground plane needs to have a material to show up in 3D viewport preview
    materialSrc: { ...MS_Color__C, colorId: DMC.SystemColors.White },
    uvGen: UVGeneration.GLOBAL_RECT_UV,
  });
}
